const FALLBACK_CONFLICT_MESSAGE = 'Nome já cadastrado.';

export interface SettingsNameConflict {
  /** Message the server sent, when it sent one. The caller falls back to the screen copy. */
  message?: string;
  /** Positions of the names as sent, counted from zero. */
  conflictingIndexes: readonly number[];
}

/**
 * Raised by an api adapter when the server refuses names that already exist. The positions travel
 * with the error because the modal needs them to highlight the offending fields.
 */
export class SettingsNameConflictError extends Error {
  readonly conflict: SettingsNameConflict;

  constructor(conflict: SettingsNameConflict) {
    super(conflict.message ?? FALLBACK_CONFLICT_MESSAGE);
    this.name = 'SettingsNameConflictError';
    this.conflict = conflict;
  }
}

export function toSettingsNameConflict(error: unknown): SettingsNameConflict | null {
  return error instanceof SettingsNameConflictError ? error.conflict : null;
}
